import {IComponentOptions, IController} from 'angular';
import {UserService} from '../../../core/services/user/user.service';
import './users-milestone-progress-bar.component.scss';

class UsersMilestoneProgressBarController implements IController {
    static $inject = [
        'UserService'
    ];

    firstPoint: any = {};
    secondPoint: any = {};

    monthEven;

    milestoneLineWidth;

    constructor(private userService: UserService) {
    }

    $onInit() {
        this.userService.getMilestone().then((data: any) => {
            const month1 = this.transformMonth(data.counter[0]);
            const month2 = this.transformMonth(data.counter[1]);
            const milestoneStart = new Date(data.start_date);

            const monthPassed = this.transformMillisecondsToMonth(new Date().getTime() - milestoneStart.getTime()) + 1;
            this.checkForMonthEven(monthPassed);

            if (!this.monthEven) {
                this.secondPoint.count = month2.count;
                this.firstPoint.count = month1.count;
            } else {
                this.firstPoint.count = month2.count;
            }

            this.countMilestoneLineWidth(monthPassed);
        });
    }

    private transformMonth(month) {
        if (month) {
            month.date = new Date(month.date);
        }
        return month;
    }

    private transformMillisecondsToMonth(date) {
        return date / 1000 / 60 / 60 / 24 / 30;
    }

    private checkForMonthEven(month) {
        const monthLeftover = month % 2;
        if (monthLeftover < 1) {
            this.firstPoint.date = Math.floor(month);
            this.secondPoint.date = this.firstPoint.date + 1;
            this.monthEven = true;
            return;
        }
        this.secondPoint.date = Math.floor(month);

        this.firstPoint.date = this.secondPoint.date - 1;
        this.monthEven = false;
    }

    private countMilestoneLineWidth(month) {
        const monthLeftOver = month % 2;
        const currentDay = new Date().getDate();
        console.log(currentDay);
        if (monthLeftOver < 1) {
            this.milestoneLineWidth = 33 + (33 * currentDay / 30);
            return;
        }
        this.milestoneLineWidth = 66 + (33 * currentDay / 30);
    }
}

export const UsersMilestoneProgressBarComponent: IComponentOptions = {
    controller: UsersMilestoneProgressBarController,
    template: require('./users-milestone-progress-bar.component.html'),
    bindings: {}
};



// WEBPACK FOOTER //
// ./app/shared/components/users-milestone-progress-bar/users-milestone-progress-bar.component.ts